t = require('views/internal/teacup-with-helpers')('reactions')

module.exports = t.renderable ({ disabled, icon, withBorder }) ->
  iconUrl = require('images/reactions/add-reaction@2x.png')
  disabledIconUrl = require('images/reactions/add-reaction-disabled@2x.png')
  activeIconUrl = require('images/reactions/add-reaction-active@2x.png')

  t.span class: t.classify('reactions-add': true, 'js-open-reactions': true, 'disabled': disabled, 'reactions-add-with-border': withBorder), ->
    # icon without border is handled by bg images via css
    if withBorder
      t.img '.reactions-add-img',
        alt: t.l 'add-reaction'
        src: if disabled then disabledIconUrl else iconUrl
        title: t.l 'add-reaction'
      t.img '.reactions-add-active-img',
        alt: t.l 'add-reaction'
        src: activeIconUrl
        title: t.l 'add-reaction'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/reaction_icon.coffee